/*******************************************************************************
SWITCH TO TAB
Switch the active filter tab.
*******************************************************************************/

import filterItems from './filter-items';
import getFilterSettings from './get-filter-settings';
import getTabSettings from './get-tab-settings';
import setMinGridWidth from '../css-grid/set-min-grid-width';

export default function switchTab(tabSetName, tabName) {

    // Find the set of tabs to use
    const $tabs = $(`.filter-tabs[data-name="${tabSetName}"]`);

    // Find the tab that was clicked on
    const $tabToSelect = $tabs.find(`.filter-tab[data-name="${tabName}"]`);

    // Add the selected class to the tab and remove it everywhere else
    $tabToSelect.addClass('is-selected').siblings('.filter-tab').removeClass('is-selected');

    // Get the settings for the filter
    const filterSettings = getFilterSettings(tabSetName);

    // Get all the settings for this specific tab
    const tabSettings = getTabSettings(tabName);

    // Show only the items that match the active filter
    filterItems(filterSettings, tabSettings);

    // If the option is in use, dynamically change the title of the section based on the tab that was clicked on
    if (filterSettings.titleTarget) {
        $(filterSettings.titleTarget).safehtml($tabToSelect.data('title'));
    }

    // If there are hidden filter tabs sets, we need to run this so they display correctly when made visible
    if ($('.filter-tabs:hidden').length > 0) {
        setMinGridWidth({ containers: '.filter-tabs', items: '.filter-tab', padding: '20' });
    }

    // Trigger a custom event that signals the tab is loaded
    $(document).trigger(`filterTabLoaded:${tabSetName}-${tabName}`, [tabSettings]);
}
